module.exports = __webpack_public_path__ + "static/media/bureau.47d974fb.jpg";